// #86: dritter Zustand 'not_configured' — neutral (Outline + gedämpfter Text), damit er weder
// als Erfolg noch als Misserfolg gelesen wird. Farbwahl nur über Token-Klassen.
export function GoNoGo({
  value,
  goLabel,
  noGoLabel,
  notConfiguredLabel,
}: {
  value: 'go' | 'no_go' | 'not_configured';
  goLabel: string;
  noGoLabel: string;
  notConfiguredLabel: string;
}) {
  const styles = {
    go: { chip: 'bg-status-pass/15 text-status-pass', dot: 'bg-status-pass' },
    no_go: { chip: 'bg-status-fail/15 text-status-fail', dot: 'bg-status-fail' },
    not_configured: {
      chip: 'border border-[var(--border)] text-text-muted',
      dot: 'bg-text-muted',
    },
  }[value];
  const label = value === 'go' ? goLabel : value === 'no_go' ? noGoLabel : notConfiguredLabel;
  return (
    <span
      data-testid="go-no-go"
      data-value={value}
      className={`inline-flex items-center gap-2 rounded-chip px-3 py-1 text-xs font-bold uppercase ${styles.chip}`}
    >
      <span className={`h-2.5 w-2.5 rounded-full ${styles.dot}`} />
      {label}
    </span>
  );
}
